<template>
<section id="skills" class="section">
    <div class="skill-title">
      <h2>Professional Skills</h2>
    </div>
    <div class="skills">
      <ul>
        <li>
          <a class="tooltip"   target="_blank">
              <font-awesome-icon class="icon html"  :icon = "['fab', 'html5']" size="4x"/>
              <span style="background-color:  #f16528;" class="tooltiptext">HTML5</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon css" style="color:#0e2431;" :icon = "['fab', 'css3-alt']" size="4x"/>
              <span style="background-color: #239ad8;" class="tooltiptext">CSS3</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon js" style="color:#0e2431;" :icon = "['fab', 'js-square']" size="4x"/>
              <span style="background-color:  #efd81d;" class="tooltiptext">JavaScript</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon node" style="color:#0e2431;" :icon = "['fab', 'node']" size="4x"/>
              <span style="background-color: #529a43;" class="tooltiptext">Node JS</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon react" style="color:#0e2431;" :icon = "['fab', 'react']" size="4x"/>
              <span style="background-color: #48cef7;" class="tooltiptext">React Native</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon laravel" style="color:#0e2431;" :icon = "['fab', 'laravel']" size="4x"/>
              <span style="background-color: #f74138;" class="tooltiptext">Laravel</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="tooltip"  target="_blank">
              <font-awesome-icon class="icon vue " style="color:#0e2431;" :icon = "['fab', 'vuejs']" size="4x"/>
              <span style="background-color: #346165;" class="tooltiptext">Vue js</span>
          </a>
        
        </li>
        
      </ul>
        
  </div>
   <!--<img id="img-skills" src="../assets/skills.jpg" alt="Foto de Lukas no Pexels">-->
</section>
</template>

<script>
export default {

}
</script>

<style scoped>
/*===SKILLS===*/
li {
  list-style: none;
}

.section {
  padding: 100px 50px;
  margin-top: 5%;
}

.skill-title {
  margin-top:3%;
}

.skill-title h2 {
  padding-bottom: 10%;
  text-align: center;
  font-size: 2.5rem;
  line-height: 4rem;
  color: #4070f4;
}
.skill-title h3 {
  padding-top: 2%;
  text-align:center;
  font-size:2rem;
  line-height: 3rem;
  color: #0e2431;
}
.skills {
  display: flex;
  justify-content: center;
  padding: 20px;
  align-items: center;
  
}


.skills a {
  margin: 0 35px;
  text-decoration: none;
  font-size: 15px;
  color:#0e2431;
  font-weight: 500;
}

/*HOVER COLORS*/

.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
 
  align-items: center;
  justify-content: center;
  margin-bottom: 65%;
  visibility: hidden;
  width: 120px;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}



.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}



.icon:hover{
  -webkit-transform: scale(0);
  transform: scale(2.5);
  transition: all 0.5s ease-in-out;
}

.skills .html:hover {
   color: #f16528!important;
}
.skills .css:hover {
   color:#239ad8!important;
}
.skills .js:hover {
   color: #efd81d!important;
}
.skills .node:hover {
   color: #529a43!important;
}
.skills .react:hover {
   color: #48cef7!important;
}
.skills .laravel:hover {
   color:#f74138!important;
}
.skills .vue:hover {
   color:#346165!important;
}


@media (max-width:700px){

  .section {
  padding: 100px 50px;
  margin-top: 10%;
  
  }

  .tooltip .tooltiptext{
    margin-bottom: 5%;
    
  }
  .skills a {
  
  margin: 0 9px;
}
  .icon {
  width: 22px;
}
.skill-title h2 {
  padding-bottom: 12%;
  text-align: center;
  font-size: 2rem;
  line-height: 2.5rem;
  color: #4070f4;
}

}

</style>